import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { filter, take } from 'rxjs';

interface RegisterAppState {
  target?: string;
}

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  protected auth = inject<AuthService<RegisterAppState>>(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  protected returnUrl = '/chat';

  constructor() {
    const requested = this.route.snapshot.queryParamMap.get('returnUrl') ?? '/chat';
    this.returnUrl = requested.startsWith('/') ? requested : '/chat';

    // If already authenticated, skip registration screen.
    this.auth.isAuthenticated$
      .pipe(
        filter(Boolean),
        take(1),
      )
      .subscribe(() => {
        this.router.navigateByUrl(this.returnUrl, { replaceUrl: true });
      });
  }

  signup(): void {
    this.auth
      .loginWithRedirect({
        authorizationParams: {
          // Auth0 Universal Login will open in "Sign up" mode.
          screen_hint: 'signup',
        },
        appState: { target: this.returnUrl },
      })
      .subscribe();
  }

  login(): void {
    this.auth
      .loginWithRedirect({
        appState: { target: this.returnUrl },
      })
      .subscribe();
  }
}

